module.exports = __webpack_public_path__ + "img/Friends_Testament_ESV_1_2.png";